export const getIsLoggedIn = state => state.session.isLoggedIn;

export const getLoginAlert = state => state.loginAlert;
